<script lang="ts">
	import PageGrid16 from '$lib/storyblok/components/pageGrid16.svelte';
	import type { ISbRichtext, ISbStoryData } from '@storyblok/js';
	import { editable } from '$lib/storyblok/editable';
	import Blok from '$lib/storyblok/blok.svelte';
	import SbRichtext from '$lib/storyblok/components/sbRichtext.svelte';
	import type { SbColor } from '$lib/storyblok/types';

	interface Props {
		content: ISbStoryData<{
			headline: string;
			subline: ISbRichtext;
			items?: ISbStoryData[];
			behavior: 'interactive' | 'static';
			column_start: '1' | '2';
			bg_color?: SbColor;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<section use:editable={content} class="py-8 lg:py-17 bg-{content.bg_color || 'white'}">
	<PageGrid16 margin>
		{#if content.headline}
			<h1
				class={[
					'col-span-full text-balance text-[44px]/[108%] tracking-[-.44px] text-brown-1 max-lg:text-center lg:text-[64px]/[110%] lg:tracking-[-.64px]',
					content.subline && (content.column_start === '1' ? 'lg:col-start-1' : 'lg:col-start-2'),
					!content.subline ? 'lg:text-center' : 'lg:col-end-8'
				]}
			>
				{content.headline}
			</h1>
		{/if}

		{#if content.subline}
			<div
				class={[
					'col-span-full mt-3 text-balance text-center text-[16px]/[150%] tracking-[-.16px] text-brown-4 lg:col-start-9 lg:mb-1.5 lg:flex lg:flex-col lg:justify-end lg:text-start lg:text-[20px]/[140%] lg:tracking-[-.20px]',
					content.column_start === '1' ? 'lg:col-end-[17]' : 'lg:col-end-[16]'
				]}
			>
				<SbRichtext text={content.subline} />
			</div>
		{/if}
		<div
			class={[
				'col-span-full',
				content.column_start === '1'
					? 'lg:col-start-1 lg:col-end-[17]'
					: 'lg:col-start-2 lg:col-end-[16]'
			]}
		>
			<div
				class={[
					'mt-7 flex flex-col gap-4 lg:mt-13 lg:grid',
					(content.items?.length || 0) < 3 ? 'lg:grid-cols-2' : 'lg:grid-cols-3'
				]}
			>
				{#each content.items || [] as item, index}
					<Blok content={item} {index} behavior={content.behavior} />
				{/each}
			</div>
		</div>
	</PageGrid16>
</section>
